// FILE: frontend/src/components/GoalsBar.jsx
// Pill-style goals bar (Patricia's design)
// Shows goal pills with states: pending, active, complete
// Visibility controlled by uiConfig.show_goals

import React from 'react'

export default function GoalsBar({ goals, goalKeys, visible }) {
  if (!visible) return null

  // goalKeys: array of goal label strings from the lesson
  // goals: { completed, total }
  const total = goals.total || 0
  const completed = goals.completed || 0

  // If we have goalKeys from the backend, show individual pills
  if (goalKeys && goalKeys.length > 0) {
    return (
      <div className="goals-bar">
        <div className="goals-label">Goals</div>
        <div className="goals-pills">
          {goalKeys.map((key, idx) => {
            let state = 'pending'
            if (idx < completed) state = 'complete'
            else if (idx === completed) state = 'active'

            return (
              <div key={idx} className={`goal-pill ${state}`}>
                {state === 'complete' ? '✓' : state === 'active' ? '💬' : '○'}
                {' '}{key}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  // Fallback: generic progress pills
  if (total === 0) return null

  const pills = Array.from({ length: total }, (_, idx) => {
    let state = 'pending'
    if (idx < completed) state = 'complete'
    else if (idx === completed) state = 'active'
    return state
  })

  return (
    <div className="goals-bar">
      <div className="goals-label">Goals</div>
      <div className="goals-pills">
        {pills.map((state, idx) => (
          <div key={idx} className={`goal-pill ${state}`}>
            {state === 'complete' ? '✓' : state === 'active' ? '💬' : '○'}
            {' '}Goal {idx + 1}
          </div>
        ))}
      </div>
    </div>
  )
}
